// src/FacilitiesCard.js

import React from 'react';
import './FacilitiesCard.css';

const FacilitiesCard = ({ title, description, image }) => {
  return (
    <div className="facilities-card">
      <img src={image} alt={title} className="facilities-image" />
      <div className="facilities-content">
        <h3 className="facilities-title">{title}</h3>
        <p className="facilities-description">{description}</p>
      </div>
    </div>
  );
};

export default FacilitiesCard;
